import React from "react";
import "./Education.css";
import Navbar from "../components/Navbar";

const Education = () => {
  return (
    <>
      <Navbar />
      <div className="energyInfra-container">
        <div className="energyInfra-content">
          <p className="para">Industries / Energy, Utilities & Smart Infrastructure</p>
          <h2>Energy, Utilities & Smart Infrastructure</h2>
          <p className="subtitle1">
            Harnessing Spatial Computing to Power Smarter Operations, Safer Environments & Skilled Workforces
          </p>
          <p>
            At Spatial Computing Technologies (SpatialCT), we support power plants, utilities, renewable energy companies, and smart infrastructure projects by delivering XR solutions that enhance operational efficiency, safety training, and real-time situational awareness. We blend AR/VR, IoT, AI, and human factors engineering into one unified immersive layer.
          </p>

          <div className="energyInfra-grid">
            <div className="energyInfra-row">
              <div className="energyInfra-box">
                <h4>XR-based Operations & Maintenance Training</h4>
                <p>Train utility workers and engineers in realistic, high-risk environments without operational downtime.</p>
                <ul>
                  <li>VR modules for turbine inspection, boiler operation, grid maintenance, etc.</li>
                  <li>Role-specific scenario training: electrical faults, lockout-tagout (LOTO), high-voltage handling</li>
                  <li>Safe, repeatable, and compliant with global EHS standards</li>
                </ul>
                <p><strong>Ideal for:</strong> Thermal, hydro, and renewable energy plants; utility providers</p>
              </div>

              <div className="energyInfra-box">
                <h4>Immersive Safety Drills & Emergency Response</h4>
                <p>Simulate rare but critical disaster scenarios (fire, leak, blackout, pressure surge) to assess response readiness.</p>
                <ul>
                  <li>Includes stress-based behavior logging and team response dynamics</li>
                  <li>Custom scenarios based on plant layout, machinery, and SOPs</li>
                  <li>AI-based feedback for post-drill debriefs</li>
                </ul>
                <p><strong>Ideal for:</strong> Disaster management cells, control room teams, fire & rescue</p>
              </div>
            </div>

            <div className="energyInfra-row">
              <div className="energyInfra-box">
                <h4>Spatial Dashboards for Real-Time Monitoring</h4>
                <p>Transform IoT sensor data into immersive spatial displays for situational decision-making.</p>
                <ul>
                  <li>Monitor grid, power consumption, equipment health via 3D dashboards</li>
                  <li>Multi-location data fusion for central command</li>
                  <li>Works with existing SCADA, PLC, and ERP systems</li>
                </ul>
                <p><strong>Ideal for:</strong> Smart cities, energy utilities, control rooms</p>
              </div>

              <div className="energyInfra-box">
                <h4>Digital Twin for Infrastructure & Smart Grids</h4>
                <p>Create real-time, data-connected 3D twins of substations, pipelines, and renewable energy farms.</p>
                <ul>
                  <li>Monitor energy flow, identify anomalies, simulate load balancing</li>
                  <li>Predictive maintenance using AI+XR overlay</li>
                  <li>Supports field worker AR assistance</li>
                </ul>
                <p><strong>Ideal for:</strong> Grid companies, smart city projects, infrastructure EPCs</p>
              </div>
            </div>

            <div className="energyInfra-row">
              <div className="energyInfra-box">
                <h4>AR Field Assistance & Remote Expert Collaboration</h4>
                <p>Equip ground engineers with AR tools to access manuals, AI diagnostics, and live remote guidance.</p>
                <ul>
                  <li>Mobile-based AR with overlay of schematics, fault lines, SOPs</li>
                  <li>Remote expert collaboration with 3D markup and audio</li>
                  <li>Real-time problem resolution, reduced field visits</li>
                </ul>
                <p><strong>Ideal for:</strong> Energy audits, plant servicing, rural electrification</p>
              </div>
            </div>
          </div>

          <div className="usecases1-section">
            <h3>Use Cases At a Glance</h3>
            <div className="usecases1-table">
              <div className="usecases1-row usecases1-header">
                <div>Use Case</div>
                <div>Industry Application</div>
                <div>Value Delivered</div>
              </div>
              <div className="usecases1-row">
                <div>XR Safety Drills</div>
                <div>Power, utilities</div>
                <div>Risk-free high-stakes training</div>
              </div>
              <div className="usecases1-row">
                <div>VR Maintenance</div>
                <div>Oil & gas, energy</div>
                <div>Reduced downtime, better SOPs</div>
              </div>
              <div className="usecases1-row">
                <div>Immersive Dashboards</div>
                <div>Smart cities</div>
                <div>Real-time decision power</div>
              </div>
              <div className="usecases1-row">
                <div>Digital Twin</div>
                <div>Infrastructure</div>
                <div>Predictive insight, remote ops</div>
              </div>
              <div className="usecases1-row">
                <div>AR Field Support</div>
                <div>Rural grids</div>
                <div>Instant expertise at hand</div>
              </div>
            </div>

            <div className="usecases1-cta">
              <h4>Partner With Us for Smarter, Safer Utilities</h4>
              <p>
                Let’s co-create XR-enabled systems that keep your infrastructure smarter and your teams safer.
                From training simulators to real-time visualizations — SpatialCT is your innovation partner for the energy transition.
              </p>
              <p>
                <b>Contact us</b> to explore a pilot project, schedule a demo, or discuss a city or plant-specific rollout.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Education;
